import React from 'react';
import './App.css';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import SideNav from './pages/SideNav';
import AcademicPrograms from './pages/AcademicsPrograms';
import Instruction from './pages/Instruction';
import Applications from './pages/Applications';
import './themes/styles.scss';
import PgForm from './pages/PgForm';
import TreeView from './pages/AcademicTreeView/index';
import ThankYouPage from './pages/ThankYouPage';
import LandingPage from './pages/landingPage/landingPage';
import { getConfig, getAxiosInstance } from './utils/ApiService';
import ConfigContext from './utils/config';
import KenLoader from './components/KenLoader/KenLoader';
import { routes } from './utils/urls';
import ThemeProvider from './theme-provider';
import lightTheme, { createLightTheme } from './themes/light-theme';

function getFaviconEl() {
  return document.getElementById('favicon');
}

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('contactID') ? (
          <Component {...props} />
        ) : (
          <Redirect to={`${routes.landing}`} />
        )
      }
    />
  );
};

function App() {
  const history = useHistory();
  const contactId = localStorage.getItem('contactID');
  if (!contactId) {
    history.replace(`${routes.draft}`);
  }

  const [config, setConfig] = React.useState();
  //console.log('config',config);
  const [loading, setLoading] = React.useState(true);
  const getApiData = async () => {
    try {
      const res = await getConfig();
      if (res && res[0].config) {
        await setConfig(res[0].config);
        await getAxiosInstance(res[0].config);
        await setLoading(false);
        const favicon = getFaviconEl(); // Accessing favicon element
        favicon.href = res[0]?.config?.favicon;
      } else {
        console.log('Error in getConfig');
      }
    } catch (err) {
      console.log('Error in config api', err);
    }
  };

  React.useEffect(() => {
    getApiData();
  }, []);

  const nextTheme =
    config && config?.customization?.palette
      ? createLightTheme(config.customization.palette)
      : lightTheme;

  return (
    <ThemeProvider theme={nextTheme}>
      <div className="App">
        {loading ? (
          <KenLoader />
        ) : (
          <ConfigContext.Provider value={{ config: config }}>
            <Switch>
              <Route exact path={`${routes.root}`}>
                <Redirect to={`${routes.draft}`}></Redirect>
              </Route>
              <Route exact path={`${routes.landing}`} component={LandingPage} />
              <ProtectedRoute
                exact
                path={`${routes.programs}`}
                component={AcademicPrograms}
              />
              <ProtectedRoute
                exact
                path={`${routes.draft}`}
                component={Applications}
              />
              <ProtectedRoute
                exact
                path={`${routes.instructions}`}
                component={Instruction}
              />
              <ProtectedRoute
                exact
                path={`${routes.pgForm}`}
                component={PgForm}
              />
              <ProtectedRoute
                exact
                path={`${routes.treeView}`}
                component={TreeView}
              />
              <ProtectedRoute
                exact
                path={`${routes.thankYou}`}
                component={ThankYouPage}
              />
              <ProtectedRoute
                exact
                path={`${routes.sidenav}`}
                component={SideNav}
              />
            </Switch>
          </ConfigContext.Provider>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
